import EditorPreview from './EditorPreview';

export default EditorPreview;
